<nz-tag class="ui-tag" [nzColor]="color" [nzBordered]="false">
  <ng-content></ng-content>
</nz-tag>
